import React from 'react';
import { Radio, Tooltip } from 'antd';
import { IconWrapper, ToolboxWrapper, DiagWrapper } from './styled';
import LineChartIco from '@icons/charts/line-ts.svg';
import DistributionIco from '@icons/charts/distribution.svg';
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons';
import { CHART_TYPE } from '../hooks/utils';
import { tid } from '@utils/test';
import track, { CLICK_CHART_MODE, CLICK_DIAGNOSTICS } from '@src/utils/sensor/track';
import { diagnosticsModeAtom, sliceAreaAtom } from '@components/metrics-panel-hz/atoms';
import { useAtom, useAtomValue } from 'jotai';
import LegendToggle from './Tools/LegendToggle';
import useCheckIfDistributionIsEnabled from '@components/metrics-panel-hz/hooks/useCheckIfDistributionIsEnabled';
import { useSelector } from 'react-redux';
import { chartIntervalTextSelector } from '@store/trends/birdChart/selectors';
import AddMetricToTable from './AddMetricToTable';

function Toolbox({ metric, chartMode, setChartMode, toggleLegend }) {
  const [diagMode, setDiagMode] = useAtom(diagnosticsModeAtom);
  const sliceArea = useAtomValue(sliceAreaAtom);
  const intervalString = useSelector(chartIntervalTextSelector);

  const onChange = (e) => {
    const { target } = e;
    track({
      event: CLICK_CHART_MODE,
      data: { metric, selectedMode: target.value },
    });
    setChartMode(target.value);
  };

  const onClickDiagnostics = () => {
    track({ event: CLICK_DIAGNOSTICS, data: { metric } });
    setDiagMode(!diagMode);
  };

  const isDistributionEnabled = useCheckIfDistributionIsEnabled(metric);

  return (
    <ToolboxWrapper>
      <LegendToggle onToggle={toggleLegend} metric={metric} chartMode={chartMode} />

      <Radio.Group
        defaultValue={chartMode}
        size="small"
        onChange={onChange}
        {...tid(`metric-card-${chartMode}`)}
      >
        <Tooltip title="Timeseries">
          <Radio.Button value={CHART_TYPE.LINE}>
            <IconWrapper>
              <LineChartIco />
            </IconWrapper>
          </Radio.Button>
        </Tooltip>

        {/* <Tooltip title="Bar">
          <Radio.Button value={CHART_TYPE.BAR}>
            <IconWrapper>
              <BarChartIco />
            </IconWrapper>
          </Radio.Button>
        </Tooltip> */}

        <Tooltip
          placement="topRight"
          title={sliceArea ? `Distribution for slice (${intervalString})` : 'Distribution'}
        >
          <Radio.Button value={CHART_TYPE.DISTRIBUTION} disabled={!isDistributionEnabled}>
            <IconWrapper>
              <DistributionIco />
            </IconWrapper>
          </Radio.Button>
        </Tooltip>
      </Radio.Group>

      <AddMetricToTable metric={metric} />

      {/* the tooltip stays behind and won't disappear without a re-render, hence the key */}
      <Tooltip
        placement="topRight"
        key={'focus-' + diagMode}
        title={diagMode ? 'Collapse' : 'Expand'}
      >
        <DiagWrapper onClick={onClickDiagnostics}>
          <IconWrapper style={{ width: 24 }}>
            {diagMode ? <ShrinkOutlined /> : <ArrowsAltOutlined />}
          </IconWrapper>
        </DiagWrapper>
      </Tooltip>
    </ToolboxWrapper>
  );
}

export default Toolbox;
